import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as firebase from 'firebase/app';
import messaging from '../init-fcm';
import { saveNotificationToken } from '../services/notification/actions';

// Simulated token for development environment
const DEVELOPMENT_TOKEN = "dev-fcm-token-for-testing-purposes-only";
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

class PushNotificationManager extends Component {
    componentDidMount() {
        this.initializePushNotifications();
    }

    initializePushNotifications = () => {
        const { user } = this.props;
        
        if (user && user.success && localStorage.getItem("enablePushNotification") === "true") {
            if (isDevelopment) {
                this.handleDevelopmentToken();
            } else if (firebase.messaging.isSupported()) {
                this.registerForPushNotifications();
            }
        }
    }

    // Development environment workaround
    handleDevelopmentToken = async () => {
        try {
            const permission = await Notification.requestPermission();
            
            if (permission === "granted") {
                // Save the development token to the backend
                const { user } = this.props;
                if (user && user.data && user.data.id && user.data.auth_token) {
                    this.props.saveNotificationToken(DEVELOPMENT_TOKEN, user.data.id, user.data.auth_token);
                }
            }
        } catch (error) {
            // Silent error handling in production
        }
    }
    
    showDevelopmentNotification = () => {
        if ('Notification' in window && Notification.permission === 'granted') {
            try {
                if ('serviceWorker' in navigator) {
                    navigator.serviceWorker.ready.then(registration => {
                        registration.showNotification('Development Mode', {
                            body: 'This is a test notification in development mode.',
                            icon: '/assets/img/favicons/favicon-96x96.png',
                            vibrate: [100, 50, 100],
                            requireInteraction: true
                        });
                    });
                }
            } catch (error) {
                // Silent error handling in production
            }
        }
    }

    registerForPushNotifications = async () => {
        const { user } = this.props;
        
        try {
            // Check if firebase messaging is properly initialized
            if (!messaging) {
                return;
            }
            
            // Request permission
            const permission = await Notification.requestPermission();
            
            if (permission === "granted") {
                try {
                    // Get token
                    const token = await messaging.getToken();
                    
                    if (token) {
                        // Save the token
                        this.props.saveNotificationToken(token, user.data.id, user.data.auth_token);
                        
                        // Set up token refresh
                        messaging.onTokenRefresh(async () => {
                            try {
                                const refreshedToken = await messaging.getToken();
                                this.props.saveNotificationToken(refreshedToken, user.data.id, user.data.auth_token);
                            } catch (error) {
                                // Silent error handling in production
                            }
                        });
                        
                        // Handle foreground messages
                        messaging.onMessage((payload) => {
                            // Create a notification if the app is in the foreground
                            if (Notification.permission === "granted") {
                                const notificationTitle = payload.data.title;
                                const notificationOptions = {
                                    body: payload.data.message,
                                    icon: payload.data.icon,
                                    image: payload.data.image,
                                    badge: payload.data.badge,
                                    data: {
                                        url: payload.data.click_action,
                                    },
                                };
                                
                                // Play notification sound
                                const audio = new Audio("/assets/audio/customer-notification.mp3");
                                audio.play();
                                
                                // Vibrate if supported
                                if ("vibrate" in navigator) {
                                    navigator.vibrate(100);
                                }
                                
                                // Show notification
                                if ('serviceWorker' in navigator) {
                                    navigator.serviceWorker.ready.then(registration => {
                                        registration.showNotification(notificationTitle, notificationOptions);
                                    });
                                }
                            }
                        });
                    }
                } catch (tokenError) {
                    // Silent error handling in production
                }
            }
        } catch (error) {
            // Silent error handling in production
        }
    }

    componentDidUpdate(prevProps) {
        // If user just logged in, try to initialize notifications
        const prevUserSuccess = prevProps && prevProps.user && prevProps.user.success;
        const currentUserSuccess = this.props.user && this.props.user.success;
        
        if (!prevUserSuccess && currentUserSuccess) {
            this.initializePushNotifications();
        }
    }

    render() {
        return null; // This component doesn't render anything
    }
}

const mapStateToProps = (state) => ({
    user: state.user
});

export default connect(mapStateToProps, { saveNotificationToken })(PushNotificationManager); 